<template>
  <div class="container-list">
    <v-container fluid>
      <div>
        <v-row class="mb-3">
          <v-col md="6"> </v-col>
          <v-col md="6">
            <v-text-field
              v-if="list_access"
              class="input-search mb-0"
              :loading="loading"
              density="compact"
              variant="outlined"
              label="Busqueda"
              prepend-inner-icon="mdi-magnify"
              v-model="searchQuery"
              @input="filterSearch"
            ></v-text-field>
          </v-col>
        </v-row>

        <Filters v-if="list_access" @loadList="loadList" :assigned="true" :service="service" />

        <Table v-if="list_access" :list="list" :header="header" :loading="loading" :toggleSort="toggleSort" :sortBy="sortBy" :sortDesc="sortDesc">
          <template v-slot:rows="{ item }">
            <td class="table-cell">{{ item.creation_date }}</td>
            <td class="table-cell">{{ item.code }}</td>
            <td class="table-cell">#{{ item.seller_order.id }}</td>
            <td class="table-cell">{{ item.destination_address }}<br />{{ item.destination_location }}</td>
            <td class="table-cell" :style="{ maxWidth: '80px' }">{{ item.bultos }}</td>
            <td class="table-cell" :style="{ maxWidth: '80px' }">{{ item.kg }}</td>
            <td class="table-cell">
              <span class="status-badge" :class="'status-shipping-' + item.state.id">
                {{ item.state.name }}
              </span>
            </td>
            <td class="table-cell text-center">
              <v-tooltip location="bottom" text="Ver visitas">
                <template v-slot:activator="{ props }">
                  <img v-bind="props" @click="viewVisit(item)" :src="require('@/assets/images/view.png')" class="mr-3 pointer icon-table" />
                </template>
              </v-tooltip>
              <v-tooltip location="bottom" text="Imprimir">
                <template v-slot:activator="{ props }">
                  <img v-bind="props" @click="print(item)" :src="require('@/assets/images/print.svg')" class="mr-2 pointer icon-table" />
                </template>
              </v-tooltip>
            </td>
          </template>
        </Table>

        <DialogLoading :dialog="loading_imprimir" text="Imprimiendo..." />
        <ModalVisits :dialog="open_modal_visit" @closeModalVisit="closeModalVisit" :shipping_id="shipping_id" :shipping_code="shipping_code" />

        <v-pagination
          v-if="cant_pages > 1"
          v-model="current_page"
          :length="cant_pages"
          @next="loadPage(service, { no_order: 0 })"
          @prev="loadPage(service, { no_order: 0 })"
          @first="loadPage(service, { no_order: 0 })"
          @update:modelValue="loadPage(service, { no_order: 0 })"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Table from "@/components/Table.vue";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import { shippingService } from "@/libs/ws/Seller/shippingService";
import Filters from "./Filters.vue";
import DialogLoading from "@/components/DialogLoading.vue";
import ModalVisits from "../Orders/ModalVisits.vue";

export default {
  name: "Employees",
  components: { Table, Filters, DialogLoading, ModalVisits },
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  data() {
    return {
      service: shippingService,
      loading: false,
      header: [
        { name: "Fecha", value: "creation_date", align: "left" },
        { name: "Codigo de seguimiento", value: "code", align: "left" },
        { name: "Nº Orden", value: "seller_order.code", align: "left" },
        { name: "Destino", value: "", align: "left" },
        { name: "Bultos", value: "bultos", align: "left", maxWidth: "80px" },
        { name: "Kg", value: "kg", align: "left", maxWidth: "80px" },
        { name: "Estado", value: "state.name", align: "left" },
        { name: "Acción", align: "center" },
      ],
      modal_title: "Envios",
      button_name: "Crear",
      loading_imprimir: false,
      params: {
        from_date: new Date().toISOString().slice(0, 10),
        to_date: new Date().toISOString().slice(0, 10),
        no_order: 0,
      },
      shipping_id: 0,
      open_modal_visit: false,
    };
  },
  watch: {
    searchQuery() {
      this.filterSearch();
    },
  },
  mounted() {
    this.$store.commit("setPageTitle", { pageTitle: [{ icon: "", page: "ENVIOS ASIGNADOS" }] });

    this.loadList(this.service, this.params);
  },
  methods: {
    closeModalVisit() {
      this.open_modal_visit = false;
      this.shipping_id = 0;
    },
    viewVisit(item) {
      this.open_modal_visit = true;
      this.shipping_id = item.id;
      this.shipping_code = item.code;
    },
    print(item) {
      this.loading_imprimir = true;

      this.service.print(item.code).then((response) => {
        try {
          //Transformo a string la respuesta para poder enviar mensajes de error.
          let result = JSON.parse(this.arrayBufferToString(response.data));
          if (!result.status) {
            this.toast.error(result.msg);
          }
        } catch (e) {
          let blob;
          let link;
        }
        this.loading_imprimir = false;
      });
    },
    arrayBufferToString(buffer) {
      var arr = new Uint8Array(buffer);
      var str = String.fromCharCode.apply(String, arr);
      if (/[\u0080-\uffff]/.test(str)) {
        throw new Error("this string seems to contain (still encoded) multibytes");
      }
      return str;
    },
  },
};
</script>
